import { trackException } from 'app-insights/appInsightsTracking';
import { ExceptionType } from 'app/enums/Common';
import { PlacementService } from 'app/services/PlacementServices/placement-service';
import { httpSuccess } from 'app/services/serviceHelpers';
import { call, getContext, put } from 'redux-saga/effects';
import { placementSummaryActions } from '../slice';
import InitPlacementSummary, { IConsolidatedRequirementResponse } from '../init.types';
import { resetFailureStatus } from '../saga';
import { extractOpts } from '../helper';

export function* requestAirportCodesPicklist() {
  try {
    yield put(resetFailureStatus('airportCodes'));

    const placementService: PlacementService = yield getContext('placementService');

    const response = yield call(placementService.getAirportCodesPicklist);
    if (httpSuccess(response?.status)) {
      yield put(
        placementSummaryActions.setOfferTransportationPickListByKey({ key: 'airportCodes', data: response.data }),
      );
    } else {
      yield put(placementSummaryActions.setServiceFailureByKey({ key: 'airportCodes', failureStatus: true }));
    }
  } catch (error) {
    trackException({
      exception: error,
      properties: {
        name: ExceptionType.APIRequestError,
        functionName: 'requestAirportCodesPicklist',
        area: 'src/store/redux-store/placement-summary/common-saga/requestAirportCodesPicklist.ts',
      },
    });
  }
}

export function processAirportCodesPicklist(
  response: IConsolidatedRequirementResponse<any>,
  context: InitPlacementSummary,
) {
  try {
    if (!httpSuccess(response?.status)) {
      context.setServiceFailureByKey({ key: 'airportCodes', failureStatus: true });
      return;
    }
    const extractedData = extractOpts('airportCodes', response.data);
    context.setOfferTransportationPickListByKey({ key: 'airportCodes', data: extractedData });
  } catch (error) {
    trackException({
      exception: error,
      properties: {
        name: ExceptionType.CommonSAGAError,
        functionName: 'processAirportCodesPicklist',
        area: 'src/store/redux-store/placement-summary/common-saga/requestAirportCodesPicklist.ts',
      },
    });
  }
}
